var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66683 12.6668H5.3335C2.66683 12.6668 1.3335 12.0002 1.3335 8.66683V5.3335C1.3335 2.66683 2.66683 1.3335 5.3335 1.3335H10.6668C13.3335 1.3335 14.6668 2.66683 14.6668 5.3335V8.66683C14.6668 11.3335 13.3335 12.6668 10.6668 12.6668H10.3335C10.1268 12.6668 9.92683 12.7668 9.80016 12.9335L8.80016 14.2668C8.36016 14.8535 7.64016 14.8535 7.20016 14.2668L6.20016 12.9335C6.0935 12.7868 5.84683 12.6668 5.66683 12.6668Z",
    stroke: "#3B3B3B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 7.33333H10.6701",
    stroke: "#3B3B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99715 7.33333H8.00314",
    stroke: "#3B3B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32967 7.33333H5.33566",
    stroke: "#3B3B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0125e9930f34704f3c0a863da9c6df6c.svg";
export { ForwardRef as ReactComponent };